import React from 'react';
import styles from './ricos-viewer.module.scss';
import { pluginLineSpacingViewer as pluginLineSpacing, pluginLinkViewer as pluginLink, pluginIndentViewer } from '@wix/ricos';
import '@wix/ricos/css/plugin-link-viewer.global.css';
import '@wix/ricos/css/plugin-collapsible-list-viewer.global.css';
import classNames from 'classnames';
import { useConfig } from '../../contexts/config-context';
import { useWixRicosViewer } from '../../contexts/ricos-viewer-context';
import { htmlAttributesPlugin } from './ricos-html-attributes-plugin';
const RicosViewer = _ref => {
  let {
    content,
    className,
    customTheme,
    dataHook = 'ricos-viewer'
  } = _ref;
  const WixRicosViewer = useWixRicosViewer();
  const {
    language
  } = useConfig();
  if (!content) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.container, className),
    "data-hook": dataHook
  }, /*#__PURE__*/React.createElement(WixRicosViewer, {
    biSettings: {
      consumer: 'Forms',
      platform: 'Livesite',
      postId: '',
      containerId: ''
    },
    instance: "",
    theme: customTheme,
    content: content,
    plugins: [htmlAttributesPlugin(), pluginLink(), pluginLineSpacing(), pluginIndentViewer()],
    locale: language
  }));
};
export default /*#__PURE__*/React.memo(RicosViewer);
//# sourceMappingURL=ricos-viewer.js.map